import { AEM_PAGES } from 'config/app-config';
import { shallowEqual, useSelector } from 'react-redux';
import { selectDataByJourney } from 'state/aem-content/aem-content-slice';
import { useNavigateToExternalURL } from 'hooks/useNavigateToExternalURL';
import { actionUrl } from 'config/static-content';
import { useLDClient } from 'launchdarkly-react-client-sdk';

export const useCrossSellData = () => {
  const navigateToExternalURL = useNavigateToExternalURL();
  const ldClient = useLDClient();
  const handleGoNext = async () => {
    ldClient?.track('cross-sell-offer-click');
    await ldClient?.flush();
    navigateToExternalURL(actionUrl.crossSellOffer);
  };
  const aemContent = useSelector(
    selectDataByJourney(AEM_PAGES.CrossSellOffer),
    shallowEqual
  );
  const dynamicMessages = aemContent?.['message-details'];
  const offerDetail = dynamicMessages?.[0];
  const showOfferDetail = !!offerDetail?.['show-message'];
  const caveatDetail = dynamicMessages?.[1];
  const showCaveatDetail = !!caveatDetail?.['show-message'];
  return {
    offerDetail,
    showOfferDetail,
    caveatDetail,
    showCaveatDetail,
    handleGoNext
  };
};
